import React, { Suspense } from 'react';
import { ThemeProvider } from 'emotion-theming';
import { HashRouter as Router, Route } from 'react-router-dom';
import { Buffer } from 'buffer';
import themeConfig from '@lyearn-team/theme-config';
// import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import DarkThemedLoader from 'components/DarkThemedLoader';

import './style/reset.css';
import './style/fonts.css';
import './style/app.css';
import './style/commonStyle.css';
import './style/redactor-custom-styles.css';
import bowser from './externalScripts/bowser.min';
import './helper/polyfills';
import './helper/handleWindowVisibility';
import './helper/handleWindowFocus';
import addGlobalCSS from './theme/addGlobalCSS';
import UserLogin from './login/views/UserLoginCheck';
import BugsnagInit from './components/BugsnagInit';
import SessionInit from './components/SessionInit';
import { translateFix } from './components/TranslateFix';
import './helper/addMasqueradeUserInCookie';

window.bowser = bowser;
global.Buffer = Buffer;

addGlobalCSS(themeConfig);

const LazyAppStack = React.lazy(() => import(/* webpackChunkName: "appstack" */ 'AppStack'));

const SuspenseWrapperAppStack = props => (
  <Suspense fallback={<DarkThemedLoader />}>
    <LazyAppStack {...props} />
  </Suspense>
);

export default class App extends React.Component {
  constructor(props) {
    super(props);

    translateFix();
  }

  renderAppStack = lcdClient => <SuspenseWrapperAppStack lcdClient={lcdClient} />;

  render() {
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      window.location.href = '/#/browser-invalid';
    }

    return (
      <BugsnagInit>
        <SessionInit />
        <ThemeProvider theme={themeConfig}>
          <Router>
            <Route render={props => <UserLogin {...props} render={this.renderAppStack} />} />
          </Router>
        </ThemeProvider>
      </BugsnagInit>
    );
  }
}
